// The admin SPA is served from /admin, the user SPA from the site root, so the
// path is the only portal signal available to code holding no router or store.
function isAdminPortal(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const path = window.location.pathname;
  return path === "/admin" || path.startsWith("/admin/");
}

// Prefix for API routes that exist under both portals and differ only in which
// auth middleware guards them (e.g. /api/ipinfo and /api/admin/ipinfo).
export function portalApiPrefix(): string {
  return isAdminPortal() ? "/admin" : "";
}
